import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

const SubmitStatus = (props) => {
  const [statusCode, setStatusCode] = useState(0);

  useEffect(() => {
    if (props.location.state) {
      const statusCode = props.location.state.statusCode;
      setStatusCode(statusCode);
    }
  }, []);

  const onClick = () => {
    props.history.push({
      pathname: "/QRCode"
    });
  };

  return (
    <div>
      {statusCode !== 0 ? (
        statusCode === 200 ? (
          <div
            style={{ marginBottom: "125px", marginTop: "125px" }}
            className="text-center"
          >
            <div
              className="swal2-icon swal2-success swal2-animate-success-icon"
              style={{ display: "flex" }}
            >
              <div
                className="swal2-success-circular-line-left"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
              <span className="swal2-success-line-tip"></span>
              <span className="swal2-success-line-long"></span>
              <div className="swal2-success-ring"></div>
              <div
                className="swal2-success-fix"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
              <div
                className="swal2-success-circular-line-right"
                style={{ backgroundColor: "rgb(255, 255, 255)" }}
              ></div>
            </div>
            <div color="green">
              Your test drive data has been successfully recorded.
            </div>
            <br />
            <input
              className="btn btn-primary"
              type="button"
              value="OK"
              onClick={onClick}
            />
          </div>
        ) : (
          <div className="text-center">
            <div
              className="swal2-icon swal2-error swal2-animate-error-icon"
              style={{ display: "flex" }}
            >
              <span className="swal2-x-mark">
                <span className="swal2-x-mark-line-left"></span>
                <span className="swal2-x-mark-line-right"></span>
              </span>
            </div>
            <div color="red">
              There was an error retrieving the data from Myinfo.
            </div>
            <br />
            <input
              className="btn btn-primary"
              type="button"
              value="OK"
              onClick={onClick}
            />
          </div>
        )
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  statusCode: state.statusCode
});

export default connect(mapStateToProps)(SubmitStatus);
